module.exports = __webpack_public_path__ + "static/media/4000R.e967abe.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/pure_tone/4000R.mp3
// module id = j+mL
// module chunks = 1